import {
  FilterMode,
  EditionCreateMutationVariables,
  Edition_OrderBy,
  Edition,
  SortOrder,
  Edition_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const editionService = {
  createOne: buildCreateOne(
    (editionCreateVariables: EditionCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.editionCreate(editionCreateVariables);
        return result.editionCreate;
      }
  ),

  editionDocumentationWorkflow_GenerateDocumentation: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.editionDocumentationWorkflow_GenerateDocumentation(
      { instanceId, instanceVersion, instanceEntity }
    );
    return result.editionDocumentationWorkflow_GenerateDocumentation;
  },

  editionDocumentationWorkflow_DeleteAndRestartFromSignature: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result =
      await api.editionDocumentationWorkflow_DeleteAndRestartFromSignature({
        instanceId,
        instanceVersion,
        instanceEntity,
      });
    return result.editionDocumentationWorkflow_DeleteAndRestartFromSignature;
  },

  editionDocumentationWorkflow_CancelGeneration: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.editionDocumentationWorkflow_CancelGeneration({
      instanceId,
      instanceVersion,
      instanceEntity,
    });
    return result.editionDocumentationWorkflow_CancelGeneration;
  },

  editionDocumentationWorkflow_DeleteAndRestartFromGenerated: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result =
      await api.editionDocumentationWorkflow_DeleteAndRestartFromGenerated({
        instanceId,
        instanceVersion,
        instanceEntity,
      });
    return result.editionDocumentationWorkflow_DeleteAndRestartFromGenerated;
  },

  editionDocumentationWorkflow_DeleteAndRestartFromFailed: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result =
      await api.editionDocumentationWorkflow_DeleteAndRestartFromFailed({
        instanceId,
        instanceVersion,
        instanceEntity,
      });
    return result.editionDocumentationWorkflow_DeleteAndRestartFromFailed;
  },

  editionDocumentationWorkflow_RetryGenerateDocumentation: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result =
      await api.editionDocumentationWorkflow_RetryGenerateDocumentation({
        instanceId,
        instanceVersion,
        instanceEntity,
      });
    return result.editionDocumentationWorkflow_RetryGenerateDocumentation;
  },

  editionDocumentationWorkflow_SendForSignature: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.editionDocumentationWorkflow_SendForSignature({
      instanceId,
      instanceVersion,
      instanceEntity,
    });
    return result.editionDocumentationWorkflow_SendForSignature;
  },

  editionDocumentationWorkflow_CancelSending: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.editionDocumentationWorkflow_CancelSending({
      instanceId,
      instanceVersion,
      instanceEntity,
    });
    return result.editionDocumentationWorkflow_CancelSending;
  },

  editionDocumentationWorkflow_RetrySendForSignature: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result = await api.editionDocumentationWorkflow_RetrySendForSignature(
      { instanceId, instanceVersion, instanceEntity }
    );
    return result.editionDocumentationWorkflow_RetrySendForSignature;
  },

  editionDocumentationWorkflow_BackToDocsFromSignatureFailed: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result =
      await api.editionDocumentationWorkflow_BackToDocsFromSignatureFailed({
        instanceId,
        instanceVersion,
        instanceEntity,
      });
    return result.editionDocumentationWorkflow_BackToDocsFromSignatureFailed;
  },

  editionDocumentationWorkflow_BorrarDocumentacionFromFallo: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result =
      await api.editionDocumentationWorkflow_BorrarDocumentacionFromFallo({
        instanceId,
        instanceVersion,
        instanceEntity,
      });
    return result.editionDocumentationWorkflow_BorrarDocumentacionFromFallo;
  },

  editionDocumentationWorkflow_ReintentarCierreFirmas: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result =
      await api.editionDocumentationWorkflow_ReintentarCierreFirmas({
        instanceId,
        instanceVersion,
        instanceEntity,
      });
    return result.editionDocumentationWorkflow_ReintentarCierreFirmas;
  },

  editionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjct: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result =
      await api.editionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjct(
        { instanceId, instanceVersion, instanceEntity }
      );
    return result.editionDocumentationWorkflow_BorrarDocumentacionDesdeEsperaDjct;
  },

  editionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplar: async (
    instanceId: string,
    instanceVersion: string,
    instanceEntity: string,
    token: string,
    activityStore: any
  ) => {
    const api = getApiInstance(token, activityStore);
    const result =
      await api.editionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplar(
        { instanceId, instanceVersion, instanceEntity }
      );
    return result.editionDocumentationWorkflow_BorrarDocumentacionDesdeFalloEjemplar;
  },
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.editionOne({ id });
    return result.editionOne as Edition;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: Edition_OrderBy[] | null = null,
    filter: Edition_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: Edition_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.editionListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.editionListWithOffset
    ) as Edition[];
    return { list, orderBy };
  },
};
